// extracted by mini-css-extract-plugin
module.exports = {"faqs":"Faqs_faqs__EuoUE"};